import { render, staticRenderFns } from "./MainTopbar.vue?vue&type=template&id=5e684196&"
import script from "./MainTopbar.vue?vue&type=script&lang=js&"
export * from "./MainTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports